<ngb-pagination *ngIf="filterParams.numberOfHits > filterParams.pageSize" class="d-flex justify-content-center mt-2" [(page)]="filterParams.pageNumber" [collectionSize]="filterParams.numberOfHits"
  [pageSize]="filterParams.pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="true"
  (pageChange)="pageChanged()"></ngb-pagination>
